// extracted by mini-css-extract-plugin
export default {"faqs":"TA-z","faqContent":"UA-z","faq":"VA-z"};